module.exports = __webpack_public_path__ + "img/3093f74.png";